import { Button } from "./ui/button";

interface Props {
  options: Array<{ value: string; displayName: string }>;
  selectedValue: string;
  onSelectValue: (value: string) => void;
}

const RadioButtons = ({ options, selectedValue, onSelectValue }: Props) => {
  return (
    <>
      {options.map((option) => (
        <Button
          key={option.value}
          variant={selectedValue === option.value ? "default" : "link"}
          onClick={() => onSelectValue(option.value)}
        >
          {option.displayName}
        </Button>
      ))}
    </>
  );
};

export default RadioButtons;
